import * as ReactRouterDom from 'react-router-dom';
import { useMemo } from 'react';

export function useQueryParams() {
  const location = ReactRouterDom.useLocation();
  return useMemo(() => new URLSearchParams(location.search), [location.search]);
}
